// extracted by mini-css-extract-plugin
export default {"lectureContainer":"Lecture_lectureContainer__KKZGb","lectureTitle":"Lecture_lectureTitle__zySb6","lectureInfo":"Lecture_lectureInfo__ISw8o"};